export const categories = [
  {
    id: "xuanxiu",
    name: "选秀记忆",
    short: "选秀",
    icon: "ri-mic-line",
    desc: "从海选到决赛夜，那些被票数和镜头记住又遗忘的人。",
    count: 42,
  },
  {
    id: "yingshi",
    name: "影视旧账",
    short: "影视",
    icon: "ri-film-line",
    desc: "尘封的剧本、删掉的镜头、没能上映的版本，都在这里翻出来。",
    count: 58,
  },
  {
    id: "yinyue",
    name: "乐坛回响",
    short: "音乐",
    icon: "ri-music-2-line",
    desc: "demo、卡带、解散与重聚，声音比人活得久。",
    count: 37,
  },
  {
    id: "zongyi",
    name: "综艺名场面",
    short: "综艺",
    icon: "ri-live-line",
    desc: "没被剪进正片的三分钟，往往才是真正的名场面。",
    count: 29,
  },
  {
    id: "wangluo",
    name: "网络初代",
    short: "网络",
    icon: "ri-global-line",
    desc: "论坛、博客、贴吧时代的顶流，如今只剩截图。",
    count: 33,
  },
];